import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { sandboxArtifactDownloadSchema } from "@/lib/data/schemas/sandbox-artifacts";
export async function getSandboxArtifactDownload(
  id: string,
  disposition: "inline" | "attachment",
) {
  const response = await authenticatedFastApiAxiosInstance.get(
    `sandbox-artifacts/${encodeURIComponent(id)}/download`,
    { params: { disposition } },
  );
  return sandboxArtifactDownloadSchema.parse(response.data);
}

export async function getSandboxArtifactPreview(id: string) {
  const response = await authenticatedFastApiAxiosInstance.get(
    `sandbox-artifacts/${encodeURIComponent(id)}/preview`,
  );
  const html: unknown = response.data?.html;
  if (typeof html !== "string" || html.length > 2 * 1024 * 1024) {
    throw new Error("This visual could not be previewed.");
  }
  return html;
}
